import React, { useState } from 'react';
import { Container, Navbar, Nav, Dropdown } from "react-bootstrap";
import "./header.css";

const AlertBanner = () => {
const [close, setClose] = useState(false);

const handleClose = () => {
  console.log("yes..")
  setClose(true);
}

  return (
    <>
      {/* {close ? null :  */}
        <div className={close?"alert-banner-box alert-banner-box-close": "alert-banner-box"} >
          <Container >
            <div className="row">
              <div className="col-1 info-icon-box"> 
                <i className="bi bi-info-circle"></i>
              </div>
              <div className="col-10 text-box" > 

                  Government officials will <strong>NEVER</strong> ask you to transfer money or disclose bank log-in details over a phone call.<br />
                  Call the 24/7 ScamShield Helpline at 1799 if you are unsure if something is a scam.

              </div>
              <div className="col-1 close-box">                
                <button  type="button" className='closeBtn' onClick={handleClose} title='close' >
                  <i className="bi bi-x"></i>
                </button>
              </div>
            </div>           
          </Container>
        </div>
      {/* }  */}
    </>
  );
};

export default AlertBanner;
